/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { ExtensionEditor } from '@bingads-webui-campaign-legacy/adextension-image/view/extensionEditor2-vnext';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import { Repository } from '@bingads-webui-campaign-legacy/adextension-image/service/repository';
import config from '@bingads-webui-component-legacy/config/index';
import { APPLY_USERINPUT_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { PANEL_WIDTH } from '../const';

export const openImageExtensionEditor = (
  opportunities,
  targetAccountId,
  campaignId,
  adGroupId,
  type,
  i18n,
  newI18n,
  editor,
  apply,
  readOnly
) => {
  const schema = window.globalLegacySchema.get('ImageAdExtension');
  const panelOptions = {
    width: PANEL_WIDTH[type],
    i18n,
    panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
  };
  const EditorCtor = panelDecorator(ExtensionEditor, panelOptions);
  const i18nKeys = {
    title: 'AdExtensions_Image_Editor_Title_PS4N',
    editTitle: 'AdExtensions_Image_Dialog_Title_Edit',
    library_title: 'AdExtensions_Image_Editor_Available_PS4N',
    selected_title: 'AdExtensions_Image_Editor_Selected_PS4N',
    create_link: 'AdExtensions_Image_Editor_CreateNew_PS4N',
    create_title: 'AdExtensions_Image_Dialog_Title_Add',
    delete_btn: 'AdExtensions_Image_Editor_Delete',
    delete_confirm: 'AdExtensions_Image_Delete_Warning_PS4N',
    edit_btn: 'AdExtensions_Image_Editor_Edit',
    edit_title: 'AdExtensions_Image_Dialog_Title_Edit_PS4N',
    inlineAlert: 'AdExtensions_Image_Max_Select_Notification',
    subtitle: ['MultiAssociationEditor_Image_Subtitle'],
  };
  editor = new EditorCtor(_.extend(
    {
      extension: null,
      data: new Repository({
        schema,
        afterChangeComitted: _.noop,
      }),
      campaignId,
      adgroupId: adGroupId,
      title: newI18n.getString(_TL_('Add new Image Extension')),
      i18nKeys: _.defaults({}, i18nKeys, {
        search_for: 'Searchbox_SearchFor',
        filter_watermark: 'AdExtensions_Search',
        save_btn: 'Button_Save',
        cancel_btn: 'Button_Cancel',
        subtitle: [],
        multiSelectInlineAlert: 'AdExtensions_MultiSelect_Max_Select_Notification',
        failedAssociationsLabel: 'AdExtensions_FailedAssociationsLabel',
        successfulAssociationsLabel: 'AdExtensions_SuccessfulAssociationsLabel',
      }),
      dialogOptions: {
        popupFront: '',
      },
      instrumentation: {
        startScenario: _.noop,
        startActivity: _.noop,
        logMessage: _.noop,
        endActivity: _.noop,
        asLoggingStart: _.constant(_.noop),
      },
      instrumentationSettings: {
        ACTIVITYNAME: {},
        SCENARIONAME: {},
      },
      disableScheduling: undefined,
      isForVNext: true,
      oDataConfig: {
        odataRootUrl: config.get('CampaignAzureDomain'),
        odataPath: config.get('odata.url') + config.get('odata.path'),
        odataToken: config.get('odata.token'),
      },
      newI18n,
    },
    {
      eventsToActions: [{
        event: 'created',
        action: () => { editor.remove(); },
      }, {
        event: 'cancel',
        action: () => { editor.remove(); },
      }],
      onClose: (entity) => {
        if ((entity.currentTarget.className === 'react-focus-lock' && entity.type === 'keyup')
          || entity.currentTarget.className === 'panel-mask'
          || (entity.currentTarget.className && entity.currentTarget.className.indexOf('panel-close') > -1)) {
          editor.remove();
        }
      },
    },
    {
      recommendation: {
        targetAccountId,
        DisplayText: opportunities[0].DisplayText,
        AltText: opportunities[0].AlternativeText,
        FinalUrls: [opportunities[0].FinalURL],
        MobileFinalUrls: [opportunities[0].MobileURL],
        StockImages: opportunities[0].StockImages,
        WebsiteImages: opportunities[0].WebsiteImages,
        ImageSourceStr: opportunities[0].ImageSourceStr,
        hasImageUrl: !_.isEmpty(opportunities[0].WebsiteImages) ||
          !_.isEmpty(_.first(opportunities[0].StockImages).ThumbnailURL),
        applyRecommendation: (data) => {
          if (data.isValid) {
            const basicInput = {
              '@odata.type': APPLY_USERINPUT_TYPES[type],
              OpportunityId: opportunities[0].OpportunityId,
            };

            const distinctImageList = _.uniq(_.map(data.imageList, image =>
              (_.isNull(image.id) ? image.src : image.id)));

            const images = _.map(distinctImageList, (key) => {
              const imageListFilteredByKey = _.filter(data.imageList, image =>
                (_.isNull(image.id) ? image.src : image.id) === key);
              return _.extend((!_.isNumber(key) ? { ImageUrl: key } : { ImageAssetId: key }), {
                AssociationMetadata: _.map(imageListFilteredByKey, image => (_.extend({
                  SubType: image.associationType,
                }, !_.isNumber(key) ? {} : {
                  CropX: image.cropSettings.SourceX,
                  CropY: image.cropSettings.SourceY,
                  CropHeight: image.cropSettings.SourceHeight,
                  CropWidth: image.cropSettings.SourceWidth,
                }))),
              });
            });

            let userInputs;
            if (opportunities[0].ImageSourceStr === 'Website') {
              userInputs = [_.extend(basicInput, {
                newImageExtensionInfo: data.newImageExtensionInfo,
                Images: images,
              })];
            } else {
              const stockImages = [];
              _.each(images, (image) => {
                if (_.has(image, 'ImageUrl')) {
                  stockImages.push({
                    AssociationMetadata: image.AssociationMetadata,
                    ImageId: _.first(opportunities[0].StockImages).ImageId,
                  });
                }
              });
              userInputs = [_.extend(basicInput, {
                newImageExtensionInfo: data.newImageExtensionInfo,
                Images: _.filter(images, image => _.has(image, 'ImageAssetId')),
                StockImages: stockImages,
              })];
            }

            apply(userInputs, editor);
          }
        },
      },
      readOnly,
    }
  )).render();
};
